export default "<div *ngIf=\"url\">\n  <img [src]=\"url\">\n</div>\n"